// src/redux/reducers/authReducer.js
const storedPermissions = localStorage.getItem("permissions");
const token = localStorage.getItem("token");

const initialState = {
  token: token || null,
  admin: null,
  isAuthenticated: !!token,
  permissions: storedPermissions ? JSON.parse(storedPermissions) : [],
};

export default function authReducer(state = initialState, action) {
  switch (action.type) {
    case "LOGIN_SUCCESS":
      return {
        ...state,
        token: action.payload.token || localStorage.getItem("token"),
        admin: action.payload,
        isAuthenticated: true,
      };
    case "SET_PERMISSIONS":
      return {
        ...state,
        permissions: action.payload,
      };
    case "LOGIN_FAIL":
    case "LOGOUT":
      return {
        ...state,
        token: null,
        admin: null,
        isAuthenticated: false,
        permissions: [],
      };
    default:
      return state;
  }
}
